import React, { useEffect, useState } from "react";
import TopHeader from "../template/TopHeader";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { cashupService } from "../../_services";
import moment from 'moment';
import CancelSaveBtn from "../new-service/add-edit-service/CancelSaveBtn";
import useWindowSize from "../new-service/useWindowSize";
import toast from '../shared/Toast';
import "./CashupDetail.css";

const CashupDetail = (props) => {
  console.log("CashupDetail component loaded");
  const { cashupId } = useParams();
  console.log("Cashup ID from URL:", cashupId);
  const [cashup, setCashup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const { width } = useWindowSize();
  // Get currency symbol from Redux with fallback to "£"
  const [currencySymbol, setCurrencySymbol] = useState(
    props.user?.userInfo?.hairdresser?.currencySymbol ||
    "£"
  );
  const [formData, setFormData] = useState({
    payments: {
      cash: { actual: 0, expected: 0 },
      card: { actual: 0, expected: 0 },
      other: { actual: 0, expected: 0 }
    },
    beuPayments: {
      terminal: 0,
      cardOnFile: 0,
      deposits: 0
    },
    endOfDay: {
      closingFloat: 0,
      cashToBank: 0
    },
    notes: ''
  });
  
  useEffect(() => {
    if (cashupId) {
      fetchCashupDetails();
    }
    
    // Update currency symbol if user info changes
    if (props.user?.userInfo?.hairdresser?.currencySymbol) {
      setCurrencySymbol(props.user.userInfo.hairdresser.currencySymbol);
    }
    
    console.log("Currency symbol from Redux:", props.user?.userInfo?.hairdresser?.currencySymbol || "£");
  }, [cashupId, props.user?.userInfo?.hairdresser?.currencySymbol]);
  
  const fetchCashupDetails = () => {
    setLoading(true);
    setIsFormChanged(false); // Reset form changed state when fetching new data
    
    console.log("Fetching cashup details for ID:", cashupId);
    
    cashupService.getCashupById(cashupId)
      .then(response => {
        console.log("Cashup detail API response:", response);
        if (response.data && response.data.status === 1) {
          const cashupData = response.data.data;
          console.log("Cashup data:", cashupData);
          console.log("Beu Payments data:", cashupData.beuPayments);
          console.log("Terminal value:", cashupData.beuPayments?.terminal);
          console.log("Card on File value:", cashupData.beuPayments?.cardOnFile);
          console.log("Deposits value:", cashupData.beuPayments?.deposits);
          setCashup(cashupData);
          
          // Initialize form data with cashup data
          setFormData({
            payments: {
              cash: {
                actual: cashupData.payments?.cash?.actual || 0,
                expected: cashupData.payments?.cash?.expected || 0
              },
              card: {
                actual: cashupData.payments?.card?.actual || 0,
                expected: cashupData.payments?.card?.expected || 0
              },
              other: {
                actual: cashupData.payments?.other?.actual || 0,
                expected: cashupData.payments?.other?.expected || 0
              }
            },
            beuPayments: {
              terminal: cashupData.beuPayments?.terminal || 0,
              cardOnFile: cashupData.beuPayments?.cardOnFile || 0,
              deposits: cashupData.beuPayments?.deposits || 0
            },
            endOfDay: {
              closingFloat: cashupData.endOfDay?.closingFloat || 0,
              cashToBank: cashupData.endOfDay?.cashToBank || 0
            },
            notes: cashupData.notes || ''
          });
        } else {
          console.error("Error fetching cashup details:", response.data);
          // Initialize with empty data
          initializeEmptyForm();
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching cashup details:", error);
        console.error("Error details:", error.response ? error.response.data : "No response data");
        console.error("Error status:", error.response ? error.response.status : "No status");
        console.error("Error message:", error.message);
        // Initialize with empty data
        initializeEmptyForm();
        setLoading(false);
      });
  };
  
  const initializeEmptyForm = () => {
    setCashup(null);
    
    // Initialize form data with empty values
    setFormData({
      payments: {
        cash: { actual: 0, expected: 0 },
        card: { actual: 0, expected: 0 },
        other: { actual: 0, expected: 0 }
      },
      beuPayments: {
        terminal: 0,
        cardOnFile: 0,
        deposits: 0
      },
      endOfDay: {
        closingFloat: 0,
        cashToBank: 0
      },
      notes: ''
    });
  };
  
  const handleInputChange = (section, field, subfield, value) => {
    // Allow empty string while typing
    const inputValue = value === '' ? '' : parseFloat(value) || 0;
    
    setFormData(prevData => {
      const newData = { ...prevData };
      
      if (subfield) {
        newData[section][field][subfield] = inputValue;
      } else {
        newData[section][field] = inputValue;
      }
      
      return newData;
    });
    
    setIsFormChanged(true);
  };
  
  // Handle blur event to convert empty strings to 0
  const handleInputBlur = (section, field, subfield) => {
    setFormData(prevData => {
      const newData = { ...prevData };
      
      if (subfield) {
        if (newData[section][field][subfield] === '') {
          newData[section][field][subfield] = 0;
        }
      } else {
        if (newData[section][field] === '') {
          newData[section][field] = 0;
        }
      }
      
      return newData;
    });
  };
  
  const handleNotesChange = (value) => {
    setFormData(prevData => ({
      ...prevData,
      notes: value
    }));
    
    setIsFormChanged(true);
  };
  
  const calculateTotals = () => {
    const { payments, beuPayments } = formData;
    
    // Ensure we're using numeric values for all calculations
    const paymentsActual =
      (parseFloat(payments.cash.actual) || 0) +
      (parseFloat(payments.card.actual) || 0) +
      (parseFloat(payments.other.actual) || 0);
      
    const paymentsExpected =
      (parseFloat(payments.cash.expected) || 0) +
      (parseFloat(payments.card.expected) || 0) +
      (parseFloat(payments.other.expected) || 0);
      
    // Make sure to parse Beu Pay values as numbers
    const beuPaymentsTotal =
      (parseFloat(beuPayments.terminal) || 0) +
      (parseFloat(beuPayments.cardOnFile) || 0) +
      (parseFloat(beuPayments.deposits) || 0);
      
    console.log("Beu Payments Total:", beuPaymentsTotal);
    console.log("Terminal:", parseFloat(beuPayments.terminal) || 0);
    console.log("Card on File:", parseFloat(beuPayments.cardOnFile) || 0);
    console.log("Deposits:", parseFloat(beuPayments.deposits) || 0);
      
    const grandTotal = paymentsActual + beuPaymentsTotal;
    const balance = paymentsActual - paymentsExpected;
    
    return {
      paymentsActual,
      paymentsExpected,
      beuPaymentsTotal,
      grandTotal,
      balance
    };
  };
  
  const handleComplete = () => {
    // Prepare the data for saving and completing
    const updatedCashup = {
      cashupId,
      userId: props.user?.userInfo?._id,
      payments: {
        cash: { actual: parseFloat(formData.payments.cash.actual) || 0 },
        card: { actual: parseFloat(formData.payments.card.actual) || 0 },
        other: { actual: parseFloat(formData.payments.other.actual) || 0 }
      },
      beuPayments: formData.beuPayments,
      endOfDay: formData.endOfDay,
      notes: formData.notes
    };
    
    console.log("Sending data to complete cashup:", updatedCashup);
    
    // Use the combined save and complete API
    cashupService.completeCashup(cashupId, updatedCashup)
      .then(response => {
        if (response.data && response.data.status === 1) {
          toast.success('Cash up completed successfully');
          setIsFormChanged(false); // Reset form changed state
          
          // Redirect to cashup list page
          props.history.push('/cashup');
        } else {
          const errorMessage = response.data?.message || 'Error completing cash up';
          toast.error(errorMessage);
        }
      })
      .catch(error => {
        console.error("Error completing cashup:", error);
        const errorMessage = error.response?.data?.message || 'Error completing cash up';
        toast.error(errorMessage);
      });
  };
  
  // Function to handle cancel button click
  const handleCancel = () => {
    // If there are unsaved changes, confirm with the user
    if (isFormChanged) {
      if (window.confirm('You have unsaved changes. Are you sure you want to cancel?')) {
        props.history.push('/cashup');
      }
    } else {
      props.history.push('/cashup');
    }
  };
  
  const formatDate = (date) => {
    return moment(date).format('dddd, Do MMMM YYYY');
  };
  
  const totals = calculateTotals();

  return (
    <div className="h_n">
      <div className="body_container cm_bg_white _nowhite">
        <TopHeader
          {...props}
          title="Cash Up"
          style={{ position: 'sticky', top: 0, zIndex: 1000 }}
          headerButtonStatus={true}
          cancelButton={true}
          cancelRefreshPage={true}
          saveReminderButton={false}
          checkoutButton={false}
          resetAllSetting={handleCancel}
          saveBookingButton={false}
          onSave={handleComplete}
        />
        <div className="new-setting-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="cashup-detail-container">
                  {width <= 1101 && <CancelSaveBtn onSave={handleComplete} />}
                  {/* Cash Up Title and Date */}
                  <div className="cashup-header">
                    <div className="cashup-title">
                      <h2>Cash Up</h2>
                    </div>
                    <div className="cashup-date">
                      {loading ? (
                        <p>Loading...</p>
                      ) : (
                        <p>{cashup ? formatDate(cashup.date) : 'N/A'}</p>
                      )}
                    </div>
                  </div>
                  
                  {/* Payment Types Section */}
                  <div className="form-input-row">
                    <div className="form-input-column">
                      <h3>Type</h3>
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Cash"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Card"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Other"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      <div className={`balance-indicator ${
                        totals.balance < 0 ? 'under' :
                        totals.balance > 0 ? 'over' :
                        'balanced'
                      }`}>
                        {totals.balance < 0 ? `${currencySymbol}${Math.abs(totals.balance).toFixed(2)} Under` :
                         totals.balance > 0 ? `${currencySymbol}${totals.balance.toFixed(2)} Over` :
                         'Balanced'}
                      </div>
                    </div>
                    
                    <div className="form-input-column actual">
                      <h3>Actual</h3>
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.payments.cash.actual}
                            onChange={(e) => handleInputChange('payments', 'cash', 'actual', e.target.value)}
                            onBlur={() => handleInputBlur('payments', 'cash', 'actual')}
                            className="form-input"
                          />
                        </div>
                      </div>
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.payments.card.actual}
                            onChange={(e) => handleInputChange('payments', 'card', 'actual', e.target.value)}
                            onBlur={() => handleInputBlur('payments', 'card', 'actual')}
                            className="form-input"
                          />
                        </div>
                      </div>
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.payments.other.actual}
                            onChange={(e) => handleInputChange('payments', 'other', 'actual', e.target.value)}
                            onBlur={() => handleInputBlur('payments', 'other', 'actual')}
                            className="form-input"
                          />
                        </div>
                      </div>
                      <div className={`balance-indicator ${
                        totals.balance < 0 ? 'under' :
                        totals.balance > 0 ? 'over' :
                        'balanced'
                      }`}>
                        {currencySymbol}{totals.paymentsActual.toFixed(2)}
                      </div>
                    </div>
                    
                    <div className="form-input-column expected">
                      <h3>Expected</h3>
                      <div className="form-input-wrapper">
                        <input
                          type="number"
                          value={formData.payments.cash.expected}
                          disabled
                          className="form-input-disabled"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <input
                          type="number"
                          value={formData.payments.card.expected}
                          disabled
                          className="form-input-disabled"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <input
                          type="number"
                          value={formData.payments.other.expected}
                          disabled
                          className="form-input-disabled"
                        />
                      </div>
                      <div className={`balance-indicator ${
                        totals.balance < 0 ? 'under' :
                        totals.balance > 0 ? 'over' :
                        'balanced'
                      }`}>
                        {currencySymbol}{totals.paymentsExpected.toFixed(2)}
                      </div>
                    </div>
                  </div>
                  
                  {/* Beu Pay Section */}
                  <div className="form-input-row">
                    <div className="form-input-column wide">
                      <h3>Beu Pay</h3>
                      {/* Beu Terminal */}
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Beu Terminal"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      {/* Card on File */}
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Card on File"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      {/* Deposits */}
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Deposits"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      <div className={`balance-indicator ${
                        totals.balance < 0 ? 'under' :
                        totals.balance > 0 ? 'over' :
                        'balanced'
                      }`}>
                        Balance
                      </div>
                    </div>
                    
                    <div className="form-input-column narrow">
                      <h3>Total</h3>
                      {/* Beu Terminal Value */}
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.beuPayments.terminal}
                            disabled
                            className="form-input-disabled"
                          />
                        </div>
                      </div>
                      {/* Card on File Value */}
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.beuPayments.cardOnFile}
                            disabled
                            className="form-input-disabled"
                          />
                        </div>
                      </div>
                      {/* Deposits Value */}
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.beuPayments.deposits}
                            disabled
                            className="form-input-disabled"
                          />
                        </div>
                      </div>
                      <div className={`balance-indicator ${
                        totals.balance < 0 ? 'under' :
                        totals.balance > 0 ? 'over' :
                        'balanced'
                      }`}>
                        {currencySymbol}{totals.beuPaymentsTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                  
                  {/* End of Day Section */}
                  <div className="form-input-row">
                    <div className="form-input-column wide">
                      <h3>End of Day</h3>
                      {/* Closing Float */}
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Closing Float"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                      {/* Cash to Bank */}
                      <div className="form-input-wrapper">
                        <input
                          type="text"
                          value="Cash to Bank"
                          readOnly
                          className="form-input-readonly"
                        />
                      </div>
                    </div>
                    
                    <div className="form-input-column narrow">
                      <h3>Amount</h3>
                      {/* Closing Float Value */}
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.endOfDay.closingFloat}
                            onChange={(e) => handleInputChange('endOfDay', 'closingFloat', null, e.target.value)}
                            onBlur={() => handleInputBlur('endOfDay', 'closingFloat')}
                            className="form-input"
                          />
                        </div>
                      </div>
                      {/* Cash to Bank Value */}
                      <div className="form-input-wrapper">
                        <div className="currency-input">
                          <span className="currency-symbol">{currencySymbol}</span>
                          <input
                            type="number"
                            value={formData.endOfDay.cashToBank}
                            onChange={(e) => handleInputChange('endOfDay', 'cashToBank', null, e.target.value)}
                            onBlur={() => handleInputBlur('endOfDay', 'cashToBank')}
                            className="form-input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Grand Total */}
                  <div className="grand-total">
                    <h3>Grand Total</h3>
                    <div className="grand-total-amount">{currencySymbol}{totals.grandTotal.toFixed(2)}</div>
                  </div>
                  
                  {/* Notes Section */}
                  <div className="notes-section">
                    <h3>Notes</h3>
                    <textarea
                      className="notes-textarea"
                      value={formData.notes}
                      onChange={(e) => handleNotesChange(e.target.value)}
                      placeholder="Add notes here..."
                    />
                  </div>
                  
                  {/* Bottom Save Button for Mobile */}
                  {width <= 1101 && (
                    <div className="bottom_fixed_btn">
                      <button
                        className="btn btn-white"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-dark"
                        onClick={handleComplete}
                        disabled={!isFormChanged}
                      >
                        {cashup && cashup.status === 'complete' ? 'Update' : 'Complete'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { user } = state;
  console.log("Redux state in CashupDetail:", state);
  console.log("User state in CashupDetail:", user);
  return {
    ...state,
    user
  };
}

export default connect(mapStateToProps)(CashupDetail);
